import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/conditionsTreated';

// Get all conditions
export async function getConditions() {
  return await sendRequest(BASE_URL, 'GET');
}

// Get filtered conditions
export async function getFilteredConditions(tag) {
  return await sendRequest(`${BASE_URL}/filter`, 'POST', tag);
}

// Create a condition
export async function postCondition(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

// Edit a condition
export async function editCondition(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

// Delete a condition
export async function deleteCondition(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
